import { render } from "./notificacionEfectoMancillado.vue?vue&type=template&id=41375ce6"
import script from "./notificacionEfectoMancillado.vue?vue&type=script&lang=js"
export * from "./notificacionEfectoMancillado.vue?vue&type=script&lang=js"

import "./notificacionEfectoMancillado.vue?vue&type=style&index=0&id=41375ce6&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__